import Tippy from "@tippyjs/react"

export const PoiGroupTooltip = () => {
    return(
        <Tippy
            content={
            <div className="text-xs max-w-[100px]">
                <p className="mb-2">POIs must be in a group to create notifications, and to be visible on Site Map and Site Map w/Pig pages.</p>
            </div>
            }
            interactive
            delay={[200, 0]}
        >
            <i
                className="fa-solid fa-circle-question text-violet-800 ml-2 cursor-help"
                aria-label="Why add POIs to groups?"
            />
        </Tippy>
    )
}

export const PoiGroupDialogDetailsTooltip = () => {
    return(
        <Tippy
            content={
            <div className="text-xs max-w-[100px]">
                <p className="mb-2">Choose a custom POI name and description specific to this group.</p>
            </div>
            }
            interactive
            delay={[200, 0]}
        >
            <i
                className="fa-solid fa-circle-question text-violet-800 ml-2 cursor-help"
                aria-label="Group specific fields"
            />
        </Tippy>
    )
}

export const PoiGroupEditorTooltip = () => {
    return(
        <Tippy
            content={
            <div className="text-sm max-w-sm">
                <p className="mb-2">Editors can change the group name and description, add/remove users, add/remove POIs, and change custom POI names and descriptions. The group creator is an editor by default.</p>
            </div>
            }
            interactive
            placement='bottom'
            delay={[200, 0]}
            appendTo={() => document.body} //if placed in EditableTable, tooltip doesn't overflow table without doing this
        >
            <i
                className="fa-solid fa-circle-question text-violet-800 ml-2 cursor-help"
                aria-label="What is a POI group editor?"
            />
        </Tippy>
    )
}

export const AddByIntersectionPointTooltip = () => {
    return(
        <Tippy
            content={
            <div className="text-sm max-w-sm">
                <p className="mb-2">If you have an intersection point, and no preference for where the POI is placed on the map, you can add it here.</p>
                <p className="mb-2">The POI flag marker will automatically be placed on the map approximately 10m away from the intersection point.</p>
                <p>If you require specific placement of the flag marker, click your preferred location on the map, then edit the intersection point in the dialog box.</p>
            </div>
            }
            interactive
            delay={[200, 0]}
        >
            <i
                className="fa-solid fa-circle-question text-violet-800 ml-2 cursor-help"
                aria-label="How does adding a POI by intersection point work?"
            />
        </Tippy>
    )
}